<template>
  <canvas ref="ripple" style="width:100vw;height:50vw;"/>
</template>


<script>
import { initCanvasRatioWidthSize } from "@/util";

export default {
  name: "Ripple",
  data() {
    return {
      canvas: null,
      canvasWidth: null,
      canvasHeight: null,
      rippleColor: null,
      offset: 0,
      minR: 0,
      maxR: 0,
      animationFrame: null,
      size: 0,
      ripple: []
    };
  },
  methods: {
    drawRipple() {
      if (!this.canvas) {
        return;
      }
      let canvas = this.canvas;
      let width = this.canvasWidth;
      let height = width;


      canvas.clearRect(0, 0, width, this.canvasHeight);
      canvas.fillStyle = '#000'
      canvas.fillRect(0, 0, width, this.canvasHeight);
      if (!this.rippleColor) {
        const rippleColor = canvas.createLinearGradient(
            0,
            0,
            width,
            0
        );
        rippleColor.addColorStop(0, "rgba(255,255,255,0.1)");
        rippleColor.addColorStop(0.5, "rgba(255,255,255,1)");
        rippleColor.addColorStop(1, "rgba(255,255,255,0.1)");
        this.rippleColor = rippleColor;
      }


      //两边+ 50px给他
      const startAngle = 0.25 * Math.PI;
      const endAngle = 0.75 * Math.PI;
      canvas.strokeStyle = this.rippleColor;


      const alphaStep = 0.9 / this.maxR;
      const lineWidthStep = 8 / this.maxR;

      for (let i = 0; i < 8; i++) {
        canvas.beginPath();
        let r = Math.round(this.ripple[i].r + this.ripple[i].offset);
        let alpha = parseFloat((1 - alphaStep * r).toFixed(2));
        let lineWidth = parseFloat((10 - lineWidthStep * r).toFixed(2));
        if (r > this.maxR) {
          this.ripple[i].r = this.minR;
          this.ripple[i].offset = 0;
        }
        canvas.globalAlpha = alpha
        canvas.lineWidth = lineWidth;
        canvas.arc(width / 2, -103, r, startAngle, endAngle, false);
        canvas.stroke();
        this.ripple[i].offset += 1;
      }
    },
    start() {
      this.drawRipple();
      this.animationFrame = requestAnimationFrame(this.start);
    }
  },

  mounted() {
    this.$nextTick(() => {
      const canvasEl = this.$refs && this.$refs.ripple;

      if (!canvasEl) {
        return
      }
      const canvasObj = initCanvasRatioWidthSize(canvasEl, canvasEl.clientWidth, canvasEl.clientHeight);
      this.canvas = canvasObj.canvas;
      this.canvasWidth = canvasObj.width;
      this.canvasHeight = canvasObj.height;


      const margin = canvasObj.height / 8;

      this.maxR = canvasObj.width / 2 + 100;
      this.minR = 103;
      console.log(`viewWidth= ${canvasObj.width},viewHeight=${canvasObj.height} `);
      for (let i = 0; i < 8; i++) {
        const r = canvasObj.width / 2 - (i * margin);
        this.ripple.push({
          r,
          offset: 0
        });
      }
      this.animationFrame = requestAnimationFrame(this.start);
    });
  },
  destroyed() {
    cancelAnimationFrame(this.animationFrame);
  }
};
</script>

<style scoped lang="less">

</style>